var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4464 5.96V21.3246C19.4464 22.9599 18.1207 24.2857 16.4853 24.2857H3.45649C1.82112 24.2857 0.495392 22.9599 0.495392 21.3246V3.55799C0.495392 1.92262 1.82112 0.59689 3.45649 0.59689H14.0833C14.2405 0.586918 14.4042 0.63934 14.5352 0.770348L19.273 5.5081C19.404 5.63911 19.4564 5.80277 19.4464 5.96ZM13.5242 1.78133H3.45649C2.47527 1.78133 1.67983 2.57677 1.67983 3.55799V21.3246C1.67983 22.3058 2.47527 23.1012 3.45649 23.1012H16.4853C17.4665 23.1012 18.262 22.3058 18.262 21.3246V6.51909H14.1164C13.7894 6.51909 13.5242 6.25394 13.5242 5.92687V1.78133ZM14.7087 2.61885V5.33465H17.4245L14.7087 2.61885Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3081 11.562L6.63507 18.2351ZM6.63504 11.562L13.3081 18.2351Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3081 11.562L6.63507 18.2351M6.63504 11.562L13.3081 18.2351",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelAssessment);
export default __webpack_public_path__ + "static/media/cancel-assessment.eb4131b04d55b74325faf7e77b43c311.svg";
export { ForwardRef as ReactComponent };